import { store } from "@/services/store";
import { Link } from "react-router-dom";
import { socialLinks } from "@/data/social";
import "./footer.css";

const paymentBrands = [
  { label: "Visa", file: "visa.svg" },
  { label: "Mastercard", file: "mastercard.svg" },
  { label: "American Express", file: "amex.svg" },
  { label: "Elo", file: "elo.svg" },
  { label: "Pix", file: "pix.svg" },
  { label: "Boleto", file: "boleto.png" },
];

const shopLinks = [
  { label: "Novidades", to: "/produtos?colecao=novidades" },
  { label: "Mais vendidos", to: "/produtos?colecao=vendidos" },
  { label: "Promoções", to: "/produtos?colecao=promocoes" },
  { label: "Ver tudo", to: "/produtos" },
];

const helpLinks = [
  { label: "Sobre a Bozzetti", to: "/sobre" },
  { label: "Meus pedidos", to: "/meus-pedidos" },
  { label: "Trocas e devoluções", to: "/politica-de-trocas" },
  { label: "Fale conosco", to: "/contato" },
  { label: "Programa de afiliados", to: "/afiliados" },
];

export default function Footer() {
  const base = import.meta.env.BASE_URL;
  return (
    <footer className="bz-footer">
      <div className="bz-footer-main">
        <div className="bz-footer-brand">
          <Link to="/" aria-label="Bozzetti Store, página inicial">
            <img src={`${base}bozzetti-logo-claro.webp`} alt="Bozzetti Store" loading="lazy" />
          </Link>
          <p>Alfaiataria feminina para o seu dia a dia.</p>
          {socialLinks.length > 0 && (
            <div className="bz-footer-social">
              {socialLinks.map((social) => (
                <a key={social.label} href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                  <i className={social.icon} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          )}
        </div>

        <nav aria-label="Comprar">
          <h2>Comprar</h2>
          <ul>{shopLinks.map((link) => <li key={link.label}><Link to={link.to}>{link.label}</Link></li>)}</ul>
        </nav>

        <nav aria-label="Ajuda">
          <h2>Ajuda</h2>
          <ul>{helpLinks.map((link) => <li key={link.label}><Link to={link.to}>{link.label}</Link></li>)}<li><a href={`${base}mapa-do-site.html`}>Mapa do site</a></li></ul>
        </nav>

        <div>
          <h2>Atendimento</h2>
          <p className="bz-footer-note">Fale com a gente pelo WhatsApp.</p>
          <a className="bz-footer-whatsapp" href={store.whatsapp} target="_blank" rel="noopener noreferrer">
            <i className="ri-whatsapp-line" aria-hidden="true"></i>{store.phone}
          </a>
          {store.email && <a className="bz-footer-email" href={`mailto:${store.email}`}>{store.email}</a>}
        </div>
      </div>

      <div className="bz-footer-pay">
        <span>Formas de pagamento</span>
        <ul>
          {paymentBrands.map(({ label, file }) => (
            <li key={label} title={label}><img src={`${base}payment/${file}`} alt={label} loading="lazy" decoding="async" /></li>
          ))}
        </ul>
      </div>

      <div className="bz-footer-legal">
        <p>© 2026 {store.legalName} · CNPJ {store.cnpj}<br />{store.address}</p>
        <a href="https://www.serraconsultora.com" target="_blank" rel="noopener noreferrer">Desenvolvido por Serra Consultoria e Tecnologia</a>
      </div>
    </footer>
  );
}
